// src/pages/HR/HRReports.js
import React from "react";
import { useNavigate } from "react-router-dom";
const reports = [
  {
    title: "Employee Directory",
    description: "View all employees and their details.",
    icon: "bi-people",
    route: "/hr/reports/employee-directory"
  },
  {
    title: "Attendance & Leave",
    description: "Track attendance, leave balances, and absenteeism trends.",
    icon: "bi-calendar-check",
    route: "/hr/reports/attendance-leave"
  },
  {
    title: "Payroll Summary",
    description: "Monthly payroll breakdown, salary, allowances, deductions.",
    icon: "bi-cash-stack",
    route: "/hr/reports/payroll-summary"
  },
  {
    title: "Salary & Compensation",
    description: "Salary structure, changes, bonuses, and incentives.",
    icon: "bi-graph-up",
    route: "/hr/reports/salary-compensation"
  },
  {
    title: "Performance Reviews",
    description: "Employee performance scores and appraisal history.",
    icon: "bi-star",
    route: "/hr/reports/performance-reviews"
  },
  {
    title: "Recruitment & Onboarding",
    description: "New hires, onboarding status, and applicant tracking.",
    icon: "bi-person-plus",
    route: "/hr/reports/recruitment-onboarding"
  }
];

export default function HRReports() {
  const navigate = useNavigate();
  return (
    <div className="container-fluid py-4">
      <h2 className="mb-4">HR Reports</h2>
      <div className="row">
        {reports.map((report, idx) => (
          <div className="col-md-4" key={idx}>
            <div className="card shadow-sm mb-4">
              <div className="card-body">
                <div className="d-flex align-items-center mb-2">
                  <i className={`bi ${report.icon}`} style={{ fontSize: 24, color: "#ff9800" }}></i>
                  <h5 className="ms-2 mb-0">{report.title}</h5>
                </div>
                <p className="text-muted">{report.description}</p>
                <button className="btn btn-outline-primary btn-sm" onClick={() => navigate(report.route)}>
                  View Report
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}